import Col from "@visa/vds/col";
import Grid from "@visa/vds/grid";
import Row from "@visa/vds/row";
import Td from "@visa/vds/td";
import Tr from "@visa/vds/tr";
import Typography from "@visa/vds/typography";
import React, { useEffect, useState } from "react";
import { trackPromise, usePromiseTracker } from "react-promise-tracker";
import { useHistory } from "react-router-dom";
import MCSConfirmDialog from "../../../components/MCSConfirmDialog";
import MCSLoading from "../../../components/MCSLoading";
import SortableTable from "../../../components/MCSSortableTable";
import { GlobalAlertContext } from "../../../context/GlobalAlertContext";
import { LibraryAdminApi } from "../../../services/library.admin.service";
import { AdminRoutes } from "../../../_constants/PageRoutes";
import ActionButtonGroup from "./Components/ActionButtonGroup";
import CategoryDialog from "./Components/CategoryDialog";
import CategoryTableActionMenu from "./Components/CategoryTableActionMenu";
import ReorderNote from "./Components/ReorderNote";

const ManageLibrary = () => {
  const history = useHistory();
  const [error, setError] = useState(null);
  const [categories, setCategories] = useState(null);
  const [category, setCategory] = useState({ id: 0, name: "" });
  const [confirmDialog, setConfirmDialog] = useState(null);
  const [isReorder, setIsReorder] = useState(false);
  const [data, setData] = useState(null);
  const [dialog, setDialog] = useState({ open: false });
  const { promiseInProgress } = usePromiseTracker();
  const colHeaders = [
    { displayName: "Category Name", name: "name", orderable: false },
    { displayName: "Admin Actions", name: "action", orderable: false },
  ];

  const deleteConfirmHandler = (id, alertObj) => {
    trackPromise(
      LibraryAdminApi.deleteCategory(id)
        .then((res) => {
          alertObj.setSuccessMessage("Delete success!");
          fetchData();
        })
        .catch((error) =>
          alertObj.setErrorMessage("Unexpected error please try again.")
        )
    );
  };

  const handleClickDelete = (e) => {
    let id = e.currentTarget.dataset.id;
    let name = e.currentTarget.dataset.name;
    setConfirmDialog({
      ...confirmDialog,
      title: "Delete Category",
      type: "warning",
      message: "Are you sure you want to delete <b>" + name + "</b> ?",
      open: true,
      id: "delete-category",
      data: id,
    });
  };

  const handleClickEdit = (e) => {
    let id = Number(e.currentTarget.dataset.id);
    let cate = categories.filter((i) => {
      return i.id === id;
    });
    if (cate && cate.length > 0) {
      setCategory(cate[0]);
      setDialog({ open: true });
    }
  };

  const handleClickManage = (e) => {
    let id = e.currentTarget.dataset.id;
    history.push({
      pathname: AdminRoutes.MANAGELIBRARY_CATEGORY,
      state: { categoryId: id },
    });
  };

  const handleClickAdd = () => {
    setCategory({ id: 0, name: "" });
    setDialog({ ...dialog, open: true });
  };

  const handleClickSaveReorder = (alertObj) => {
    let reOrdered = categories.map(function (d, index, arr) {
      d.orderNumber = index;
      return d;
    });
    trackPromise(
      LibraryAdminApi.updatCategoryOrder(reOrdered)
        .then((res) => {
          setData({ data, categories: reOrdered });
          alertObj.setSuccessMessage("Save success!");
        })
        .catch((error) => alertObj.setErrorMessage(error))
    );
  };

  const handleClickCancelReorder = () => {
    setCategories(data.categories);
  };

  const handleClickSave = (alertObj, updateDto) => {
    setDialog({ open: false });
    trackPromise(
      LibraryAdminApi.saveCategory(updateDto)
        .then((res) => {
          alertObj.setSuccessMessage("Save success!");
          fetchData();
        })
        .catch((error) => {
          alertObj.setErrorMessage(error);
        })
    );
  };

  const fetchData = async () =>
    trackPromise(
      LibraryAdminApi.getCategoryList()
        .then((result) => {
          setData(result.data);
          setCategories(result.data.categories);
        })
        .catch((error) => setError(error))
    );

  useEffect(() => {
    fetchData();
  }, []);

  if (error) {
    return <div>Error: {error.message}</div>;
  } else {
    return (
      <GlobalAlertContext.Consumer>
        {(alertObj) => (
          <>
            {confirmDialog && (
              <MCSConfirmDialog
                alertObj={alertObj}
                confirmHandler={deleteConfirmHandler}
                confirmDialog={confirmDialog}
                setConfirmDialog={setConfirmDialog}
              />
            )}
            <CategoryDialog
              alertObj={alertObj}
              dialog={dialog}
              setDialog={setDialog}
              category={category}
              handleClickSave={handleClickSave}
            />
            <Grid>
              <Row>
                <Col>
                  <Typography tag="h1">Manage Library</Typography>
                </Col>
              </Row>
              {promiseInProgress && <MCSLoading />}
              {!promiseInProgress && categories && (
                <>
                  <Row>
                    <Col xs={4} sm={4} md={6} lg={8} xl={8}></Col>
                    <Col>
                      <ActionButtonGroup
                        btnAddText="Add New Category"
                        alertObj={alertObj}
                        isReorder={isReorder}
                        disableReorder={categories.length === 0}
                        setIsReorder={setIsReorder}
                        handleClickAdd={handleClickAdd}
                        handleClickSaveReorder={handleClickSaveReorder}
                        handleClickCancelReorder={handleClickCancelReorder}
                      />
                    </Col>
                  </Row>
                  {isReorder && <ReorderNote />}
                  <Row>
                    <Col>
                      <SortableTable
                        disabled={!isReorder}
                        colHeaders={colHeaders}
                        setDataSource={setCategories}
                        dataSource={categories}
                        tableBody={
                          categories &&
                          categories.map((row, key) => (
                            <Tr key={key}>
                              <Td className={isReorder ? "vss-handle" : ""}>
                                {row.name}
                              </Td>
                              <Td>
                                {!isReorder && (
                                  <CategoryTableActionMenu
                                    dataId={row.id}
                                    dataName={row.name}
                                    handleClickManage={handleClickManage}
                                    handleClickEdit={handleClickEdit}
                                    handleClickDelete={handleClickDelete}
                                  />
                                )}
                              </Td>
                            </Tr>
                          ))
                        }
                      />
                    </Col>
                  </Row>
                </>
              )}
            </Grid>
          </>
        )}
      </GlobalAlertContext.Consumer>
    );
  }
};
export default ManageLibrary;
